module.exports = __webpack_public_path__ + "img/HG.de1a833f.jpg";